
import { defineComponent, PropType } from '@vue/composition-api'

import { useChatListTotalUnreadChatCountProvider } from '@/features/errands/chat/stores/chatsStore'
import { RouteDefinition } from '@/infrastructure/router/routeDefinition'

export default defineComponent({
  props: {
    isAuthenticated: { type: Boolean, required: true },
    authBusyLoading: { type: Boolean, required: true },
    authHasError: { type: Boolean, required: true },
    routes: { type: Array as PropType<Array<RouteDefinition>>, required: true },
    showSidenav: { type: Boolean },
  },

  setup() {
    const { totalUnreadCount } = useChatListTotalUnreadChatCountProvider({ forceReload: true })

    return {
      totalUnreadCount,
    }
  },

  data() {
    return {
      drawer: null,
    }
  },
})
